import { render, staticRenderFns } from "./TopSellingProductsTab.vue?vue&type=template&id=69a532a3"
import script from "./TopSellingProductsTab.vue?vue&type=script&lang=js"
export * from "./TopSellingProductsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports